import { useQuery } from '@tanstack/react-query';
import { queries } from '../../../../queries';
import type { Nullable } from '../../../../types/common/utility';

export function useSubmissionDetails(submissionId: Nullable<string>) {
  return useQuery({
    ...queries.submissions.details(submissionId),
    keepPreviousData: true,
    retry: false,
    enabled: !!submissionId,
    onError: () => {
      // Silently ignore errors when fetching submission details
    },
  });
}